/**
 * Social service registry (editor copy).
 *
 * DUPLICATED IN PHP: `Blocks/SocialIcons.php::SERVICES` holds the same slugs,
 * labels, icons and brand colours. Two runtimes, no shared module — the editor
 * needs it as an ES module and the renderer needs it before any JS runs. Change
 * one, change the other. The same posture is documented in
 * `JumpToSection::normalize_legacy_attributes` vs `JumpToSection/deprecated.jsx`.
 *
 * `icon` values are Phosphor glyph names; every one is present in
 * `src/components/IconsModal/icons.json`, which is also what IconCssService
 * generates frontend CSS from.
 */

export const SERVICES = {
  facebook: {
    label: 'Facebook',
    icon: 'facebook-logo',
    color: '#1877F2',
    placeholder: 'https://facebook.com/yourpage',
  },
  x: {
    label: 'X',
    icon: 'x-logo',
    color: '#000000',
    placeholder: 'https://x.com/yourhandle',
  },
  twitter: {
    label: 'Twitter',
    icon: 'twitter-logo',
    color: '#1DA1F2',
    placeholder: 'https://twitter.com/yourhandle',
  },
  instagram: {
    label: 'Instagram',
    icon: 'instagram-logo',
    color: '#E4405F',
    placeholder: 'https://instagram.com/yourhandle',
  },
  linkedin: {
    label: 'LinkedIn',
    icon: 'linkedin-logo',
    color: '#0A66C2',
    placeholder: 'https://linkedin.com/in/yourprofile',
  },
  youtube: {
    label: 'YouTube',
    icon: 'youtube-logo',
    color: '#FF0000',
    placeholder: 'https://youtube.com/@yourchannel',
  },
  vimeo: {
    label: 'Vimeo',
    // Phosphor ships no Vimeo glyph. A service may instead carry its own mark
    // as a 24x24 path; an empty `icon` is what switches both runtimes over to
    // rendering an inline <svg>. Everything else about the entry is unchanged,
    // so a service with its own mark is not a second-class citizen.
    icon: '',
    svgPath:
      'M23.9765 6.4168c-.105 2.338-1.739 5.5429-4.894 9.6088-3.2679 4.247-6.0258 6.3699-8.2898 6.3699-1.409 0-2.578-1.294-3.553-3.881l-1.9179-7.1138c-.719-2.584-1.488-3.878-2.312-3.878-.179 0-.806.378-1.8809 1.132l-1.129-1.457a315.06 315.06 0 003.501-3.1279c1.579-1.365 2.765-2.081 3.5539-2.156 1.867-.18 3.016 1.1 3.447 3.838.465 2.953.789 4.789.971 5.5069.539 2.45 1.131 3.674 1.778 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.121-1.777.391 1.186-3.8679 3.434-5.7568 6.762-5.6368 2.473.06 3.628 1.664 3.474 4.797z',
    color: '#1AB7EA',
    placeholder: 'https://vimeo.com/yourhandle',
  },
  tiktok: {
    label: 'TikTok',
    icon: 'tiktok-logo',
    color: '#010101',
    placeholder: 'https://tiktok.com/@yourhandle',
  },
  threads: {
    label: 'Threads',
    icon: 'threads-logo',
    color: '#000000',
    placeholder: 'https://threads.net/@yourhandle',
  },
  pinterest: {
    label: 'Pinterest',
    icon: 'pinterest-logo',
    color: '#BD081C',
    placeholder: 'https://pinterest.com/yourprofile',
  },
  whatsapp: {
    label: 'WhatsApp',
    icon: 'whatsapp-logo',
    color: '#25D366',
    placeholder: 'https://wa.me/1234567890',
  },
  telegram: {
    label: 'Telegram',
    icon: 'telegram-logo',
    color: '#26A5E4',
    placeholder: 'https://t.me/yourhandle',
  },
  discord: {
    label: 'Discord',
    icon: 'discord-logo',
    color: '#5865F2',
    placeholder: 'https://discord.gg/yourinvite',
  },
  twitch: {
    label: 'Twitch',
    icon: 'twitch-logo',
    color: '#9146FF',
    placeholder: 'https://twitch.tv/yourchannel',
  },
  snapchat: {
    label: 'Snapchat',
    icon: 'snapchat-logo',
    color: '#FFFC00',
    placeholder: 'https://snapchat.com/add/yourhandle',
  },
  reddit: {
    label: 'Reddit',
    icon: 'reddit-logo',
    color: '#FF4500',
    placeholder: 'https://reddit.com/user/yourhandle',
  },
  github: {
    label: 'GitHub',
    icon: 'github-logo',
    color: '#181717',
    placeholder: 'https://github.com/yourhandle',
  },
  gitlab: {
    label: 'GitLab',
    icon: 'gitlab-logo',
    color: '#FC6D26',
    placeholder: 'https://gitlab.com/yourhandle',
  },
  dribbble: {
    label: 'Dribbble',
    icon: 'dribbble-logo',
    color: '#EA4C89',
    placeholder: 'https://dribbble.com/yourhandle',
  },
  behance: {
    label: 'Behance',
    icon: 'behance-logo',
    color: '#1769FF',
    placeholder: 'https://behance.net/yourhandle',
  },
  figma: {
    label: 'Figma',
    icon: 'figma-logo',
    color: '#F24E1E',
    placeholder: 'https://figma.com/@yourhandle',
  },
  medium: {
    label: 'Medium',
    icon: 'medium-logo',
    color: '#000000',
    placeholder: 'https://medium.com/@yourhandle',
  },
  spotify: {
    label: 'Spotify',
    icon: 'spotify-logo',
    color: '#1DB954',
    placeholder: 'https://open.spotify.com/artist/yourid',
  },
  soundcloud: {
    label: 'SoundCloud',
    icon: 'soundcloud-logo',
    color: '#FF5500',
    placeholder: 'https://soundcloud.com/yourhandle',
  },
  mastodon: {
    label: 'Mastodon',
    icon: 'mastodon-logo',
    color: '#6364FF',
    placeholder: 'https://mastodon.social/@yourhandle',
  },
  messenger: {
    label: 'Messenger',
    icon: 'messenger-logo',
    color: '#00B2FF',
    placeholder: 'https://m.me/yourpage',
  },
  email: {
    label: 'Email',
    icon: 'envelope',
    color: '#4B5563',
    placeholder: 'you@example.com',
  },
  phone: {
    label: 'Phone',
    icon: 'phone-call',
    color: '#4B5563',
    placeholder: '+1 234 567 890',
  },
  website: {
    label: 'Website',
    icon: 'globe',
    color: '#4B5563',
    placeholder: 'https://example.com',
  },
  custom: {
    label: 'Custom',
    icon: 'link',
    color: '#4B5563',
    placeholder: 'https://example.com',
  },
};

/** Options list for the editor's service picker, alphabetical with Custom last. */
export const SERVICE_OPTIONS = Object.keys(SERVICES)
  .filter((slug) => slug !== 'custom')
  .sort((a, b) => SERVICES[a].label.localeCompare(SERVICES[b].label))
  .map((slug) => ({ value: slug, label: SERVICES[slug].label }))
  .concat([{ value: 'custom', label: SERVICES.custom.label }]);

/**
 * Resolve a service entry, falling back to `custom` for unknown slugs so a
 * hand-edited or future-dated attribute never renders an empty icon.
 *
 * @param {string} slug Service slug.
 * @return {Object} Registry entry.
 */
export function getService(slug) {
  return SERVICES[slug] || SERVICES.custom;
}

/**
 * Phosphor class name for an icon at a given weight.
 *
 * @param {string} name   Glyph name.
 * @param {string} weight regular | fill | duotone.
 * @return {string} Class string, or '' when there is no glyph.
 */
export function getIconClass(name, weight = 'fill') {
  if (!name) {
    return '';
  }
  return `ph${weight !== 'regular' ? `-${weight}` : ''} ph-${name}`;
}

/**
 * The inline mark a service brings for itself, if any.
 *
 * Only set for services Phosphor does not cover (Vimeo today). Custom-icon
 * children always use the Phosphor picker, so they never take this path.
 *
 * @param {string} slug Service slug.
 * @return {string} SVG path data, or '' when the service uses a Phosphor glyph.
 */
export function getServiceSvgPath(slug) {
  return getService(slug).svgPath || '';
}
